import { fieldTypes } from "@icarius-utils/constants";

const NAME = "ONBOARDING_TRACKING";

export const COLLABORATOR_FIELDS = [
    {
        name: "contractDate",
        label: "incomeDate",
        readOnlyType: fieldTypes.text,
    },
    {
        name: "manager",
        label: "manager",
        readOnlyType: fieldTypes.text,
    },
    {
        name: "functionaryType",
        label: "fType",
        readOnlyType: fieldTypes.text,
    },
    {
        name: "management",
        label: "management",
        readOnlyType: fieldTypes.text,
    },
    {
        name: "department",
        label: "department",
        readOnlyType: fieldTypes.text,
    },
    {
        name: "workplace",
        label: "jobLocation",
        readOnlyType: fieldTypes.text,
    },
    {
        name: "division",
        label: "SHOW_DIVISION",
        readOnlyType: fieldTypes.text,
    },
    {
        name: "costCenter",
        label: "costCenter",
        readOnlyType: fieldTypes.text,
    },
    {
        name: "position",
        label: "position",
        readOnlyType: fieldTypes.text,
    },
    {
        name: "workModality",
        label: "workMode",
        readOnlyType: fieldTypes.text,
    },
    {
        name: "cellphone",
        label: "cellphoneVisibleShort",
        readOnlyType: fieldTypes.phone,
    },
    {
        name: "email",
        label: "email",
        readOnlyType: fieldTypes.email,
    },
];

export default NAME;
